import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls window to top on every route change.
 * Skips scrolling when the URL contains a hash fragment (e.g. #section).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    // Immediate jump (no smooth) so the user isn't confused seeing the previous page's bottom flash
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}
